// components/FadeIn.tsx
import React, { FC, ReactNode } from 'react';

interface FadeInProps {
  duration?: number; // ms
  delay?: number; // ms
  className?: string;
  children: ReactNode;
}

const FadeIn: FC<FadeInProps> = ({
  children,
  duration = 500,
  delay = 0,
  className = '',
}) => {
  const style: React.CSSProperties = {
    animationName: 'fade-scale',
    animationDuration: `${duration}ms`,
    animationDelay: `${delay}ms`,
    animationTimingFunction: 'ease-out',
    animationFillMode: 'forwards',
  };

  return (
    <div
      style={style}
      // opacity-0 로 안 보이는 상태로 시작
      className={`opacity-0 origin-center ${className}`}
    >
      {children}
    </div>
  );
};

export default FadeIn;
